export default {
  "delay-card": {
    scales: {
      DAY: "jour",
      HOUR: "heure",
    },
    "service-types": {
      MAYOR: "Pour habitation",
      MAYOR_LARGE_PRODUCER: "Pour commercial",
      GRID_CONNECTION: "< 36kVa)",
      GRID_CONNECTION_LARGE_PRODUCER: "36-250kVa",
      GRID_CONNECTION_LARGE_PRODUCER_HTA_250_TO_500_KVA: "250-500kVa",
      GRID_CONNECTION_LARGE_PRODUCER_HTA_ABOVE_500_KVA: ">500kVa",
      CONSUEL: "Pour habitation",
      CONSUEL_LARGE_PRODUCER: "Pour commercial",
    },

    statuses: {
      title: "Statuts",
      MAYOR: {
        SENT: "Envoyée",
        CONFIRMED: "Récépissé obtenu",
        APPROVED: "Non-opposition obtenue",
        REJECTED: "Opposition obtenue",
        DAACT_SENT: "DAACT envoyée",
        DAACT_CONFIRMED: "DAACT récépissé obtenu",
        DAACT_COMPLETE: "DAACT validée",
      },
      MAYOR_LARGE_PRODUCER: {
        SENT: "Envoyée",
        CONFIRMED: "Récépissé obtenu",
        ACCEPTED: "Non-opposition obtenue",
        REJECTED: "Opposition obtenue",
        DAACT_SENT: "DAACT envoyée",
        DAACT_CONFIRMED: "DAACT récépissé obtenu",
        DAACT_COMPLETE: "DAACT validée",
      },
      GRID_CONNECTION: {
        ENEDIS_F2_SENT: "Envoyée",
        ENEDIS_F2_CONFIRMED: "Dossier complet",
        ENEDIS_PDR_SENT: "PDR obtenue",
        ENEDIS_PDR_ACCEPTED: "PDR acceptée",
        ENEDIS_MISE_SERVICE_REQUESTED: "MES commandée",
        ENEDIS_URBAN_SOLAR_CONFIRMED: "Dossier créé",
        ENEDIS_URBAN_SOLAR_SUBSCRIBED: "Contrat signée",
        ENEDIS_URBAN_SOLAR_SENT: "Dossier envoyé",
        ENEDIS_URBAN_SOLAR_APPROVED: "MES réalisée",
        ENEDIS_URBAN_SOLAR_REJECTED: "Dossier refusé",
        ENEDIS_F2_REJECTED: "Dossier refusé",
        REVISION_ONGOING: "Demande de pièce pas encore traitée",
        REVISION_SENT: "Demande de pièce traitée",
        PREPARING: "En préparation",
        SENT: "Envoyée",
        CONFIRMED: "Complétude validée",
        DIRECT_CONNECTION_AGREEMENT_PREPARED: "CRD en attente de signature",
        DIRECT_CONNECTION_AGREEMENT_SIGNED: "CRD signé",
        ENEDIS_CONSTRUCTION_QUOTE_TRANSFERRED: "Devis du GDR disponible",
        ENEDIS_CONSTRUCTION_QUOTE_SIGNED: "Devis du GDR signé",
        ENEDIS_CONSTRUCTION_QUOTE_DOWNPAYMENT: "Paiement de l'acompte",
        ENEDIS_CONSTRUCTION_SCHEDULED: "Planification des travuax du GDR",
        ENEDIS_CONSTRUCTION_COMPLETE: "Travaux du GDR réalisés",
        ENEDIS_CONSTRUCTION_QUOTE_FINALPAYMENT: "Paiement du solde",
        ENEDIS_CONSUEL_APPROVAL: "Accord du Consuel",
        GRID_CONNECTION_CONTRACT_PREPARED: "En attente du contrat CARD-i",
        GRID_CONNECTION_CONTRACT_SIGNED: "CARD-i signé",
        ENEDIS_MISE_SERVICE_VISIT_SCHEDULED: "MES planifiée",
        ENEDIS_MISE_SERVICE_VISIT_COMPLETE: "MES réalisée",
        REJECTED: "Dossier refusé",
      },
      GRID_CONNECTION_LARGE_PRODUCER: {
        SENT: "Envoyée",
        CONFIRMED: "Complétude validée",
        DIRECT_CONNECTION_AGREEMENT_PREPARED: "CRD en attente de signature",
        DIRECT_CONNECTION_AGREEMENT_SIGNED: "CRD signé",
        ENEDIS_CONSTRUCTION_QUOTE_TRANSFERRED: "Devis du GDR disponible",
        ENEDIS_CONSTRUCTION_QUOTE_SIGNED: "Devis du GDR signé",
        ENEDIS_CONSTRUCTION_QUOTE_DOWNPAYMENT: "Paiement de l'acompte",
        ENEDIS_CONSTRUCTION_SCHEDULED: "Planification des travuax du GDR",
        ENEDIS_CONSTRUCTION_COMPLETE: "Travaux du GDR réalisés",
        ENEDIS_CONSTRUCTION_QUOTE_FINALPAYMENT: "Paiement du solde",
        ENEDIS_CONSUEL_APPROVAL: "Accord du Consuel",
        GRID_CONNECTION_CONTRACT_PREPARED: "En attente du contrat CARD-i",
        GRID_CONNECTION_CONTRACT_SIGNED: "CARD-i signé",
        ENEDIS_MISE_SERVICE_VISIT_SCHEDULED: "MES planifiée",
        ENEDIS_MISE_SERVICE_VISIT_COMPLETE: "MES réalisée",
        REJECTED: "Dossier refusé",
      },
      GRID_CONNECTION_LARGE_PRODUCER_HTA_250_TO_500_KVA: {
        SENT: "Envoyée",
        CONFIRMED: "Complétude validée",
        DIRECT_CONNECTION_AGREEMENT_PREPARED: "CRD en attente de signature",
        DIRECT_CONNECTION_AGREEMENT_SIGNED: "CRD signé",
        ENEDIS_CONSTRUCTION_QUOTE_TRANSFERRED: "Devis du GDR disponible",
        ENEDIS_CONSTRUCTION_QUOTE_SIGNED: "Devis du GDR signé",
        ENEDIS_CONSTRUCTION_QUOTE_DOWNPAYMENT: "Paiement de l'acompte",
        ENEDIS_CONSTRUCTION_SCHEDULED: "Planification des travuax du GDR",
        ENEDIS_CONSTRUCTION_COMPLETE: "Travaux du GDR réalisés",
        ENEDIS_CONSTRUCTION_QUOTE_FINALPAYMENT: "Paiement du solde",
        ENEDIS_CONSUEL_APPROVAL: "Accord du Consuel",
        GRID_CONNECTION_CONTRACT_PREPARED: "En attente du contrat CARD-i",
        GRID_CONNECTION_CONTRACT_SIGNED: "CARD-i signé",
        ENEDIS_MISE_SERVICE_VISIT_SCHEDULED: "MES planifiée",
        ENEDIS_MISE_SERVICE_VISIT_COMPLETE: "MES réalisée",
        REJECTED: "Dossier refusé",
      },
      GRID_CONNECTION_LARGE_PRODUCER_HTA_ABOVE_500_KVA: {
        SENT: "Envoyée",
        CONFIRMED: "Complétude validée",
        DIRECT_CONNECTION_AGREEMENT_PREPARED: "CRD en attente de signature",
        DIRECT_CONNECTION_AGREEMENT_SIGNED: "CRD signé",
        ENEDIS_CONSTRUCTION_QUOTE_TRANSFERRED: "Devis du GDR disponible",
        ENEDIS_CONSTRUCTION_QUOTE_SIGNED: "Devis du GDR signé",
        ENEDIS_CONSTRUCTION_QUOTE_DOWNPAYMENT: "Paiement de l'acompte",
        ENEDIS_CONSTRUCTION_SCHEDULED: "Planification des travuax du GDR",
        ENEDIS_CONSTRUCTION_COMPLETE: "Travaux du GDR réalisés",
        ENEDIS_CONSTRUCTION_QUOTE_FINALPAYMENT: "Paiement du solde",
        ENEDIS_CONSUEL_APPROVAL: "Accord du Consuel",
        GRID_CONNECTION_CONTRACT_PREPARED: "En attente du contrat CARD-i",
        GRID_CONNECTION_CONTRACT_SIGNED: "CARD-i signé",
        ENEDIS_MISE_SERVICE_VISIT_SCHEDULED: "MES planifiée",
        ENEDIS_MISE_SERVICE_VISIT_COMPLETE: "MES réalisée",
        REJECTED: "Dossier refusé",
      },
      CONSUEL: {
        SENT: "Demande envoyé",
        APPROVED: "AC visé",
        REJECTED: "AC refusé",
      },
      CONSUEL_LARGE_PRODUCER: {
        ELECTRICAL_SAFETY_INSPECTION_QUOTE_REQUESTED:
          "Bureau de contrôle prépare devis",
        ELECTRICAL_SAFETY_INSPECTION_QUOTE_RECEIVED:
          "Devis du bureau de contrôle à faire signé",
        ELECTRICAL_SAFETY_INSPECTION_QUOTE_SIGNED:
          "Bureau de contrôle planifie l'inspection",
        ELECTRICAL_SAFETY_INSPECTION_SCHEDULED:
          "L’inspection du bureau de contrôle est planifié",
        ELECTRICAL_SAFETY_INSPECTION_COMPLETE:
          "Certificat de confirmité DRE obtenu",
        SENT: "Demande envoyé",
        APPROVED: "AC visé",
        REJECTED: "AC refusé",
      },
    },
  },
}
